<template>
  <ErrorPage code="403" />
</template>

<script>
import ErrorPage from "@/components/Common/ErrorPage.vue";

// Signed in, but the role may not open the page
export default {
  name: "Forbidden",
  components: { ErrorPage },
};
</script>
